// features/hive/ui/HiveChartSection/HiveMarkActions.tsx
import { FC } from "react";
import { ChartActions } from "features/hive/ui/HiveChartSection/styles.ts";

export type HiveMarkActionsProps = {
    onEdit: () => void;
    onDuplicate: () => void;
    onDelete: () => void;
};

export const HiveMarkActions: FC<HiveMarkActionsProps> = ({ onEdit, onDuplicate, onDelete }) => {
    return (
        <ChartActions>
            <p onClick={onEdit}>Редактировать</p>
            <p onClick={onDuplicate}>Дублировать</p>
            <p onClick={onDelete}>Удалить</p>
        </ChartActions>
    );
};
